/*
 * @Description: 
 * @Author: huangshiwen
 * @Date: 2022-05-30 13:37:36
 * @LastEditTime: 2022-06-28 13:24:18
 */
export const routerMap = [
  {
    path:"/",
    redirect:"/personalCenter/login"
  },
  {
    path:"/personalCenter/login",
    name:"login",
    meta: { title: '登录' },
    component:()=>import(/* webpackChunkName: "login" */ '@/views/login')
  },
  {
    path:"/personalCenter/register",
    name:"register",
    meta: { title: '注册' },
    component:()=>import(/* webpackChunkName: "register" */ '@/views/register')
  },
  {
    path:"/personalCenter/resetPassword",
    name:"resetPassword",
    meta: { title: '忘记密码' },
    component:()=>import(/* webpackChunkName: "resetPassword" */ '@/views/resetPwd')
  },
  {
    path:"/personalCenter/modifyPassword",
    name:"modifyPassword",
    meta: { title: '修改密码' },
    component:()=>import(/* webpackChunkName: "modifyPassword" */ '@/views/modifyPwd')
  },
  {
    path:"/personalCenter/personalInfomation",
    name:"hospitalPersonalInfomation",
    meta: { title: '个人中心页' },
    component:()=>import(/* webpackChunkName: "hospitalPersonalInfomation" */ '@/views/hospitalPersonalInfomation')
  },
  {
    path:"/personalCenter/hospitalBookTab",
    name:"hospitalBookTab",
    meta: { title: '预约挂号Tab切换' },
    component:()=>import(/* webpackChunkName: "hospitalBookTab" */ '@/views/hospitalBookTab')
  },
  {
    path:"/medicalCenter/medicalPlan",
    name:"physicalExamination",
    meta: { title: '体检列表' },
    component:()=>import(/* webpackChunkName: "physicalExamination" */ '@/views/hospitalExamination')
  },
  {
    path:"/medicalCenter/appBook",
    name:"hospitalAPPBook",
    meta: { title: 'App预约' },
    component:()=>import(/* webpackChunkName: "hospitalAPPBook" */ '@/views/hospitalAPPBook')
  },
  {
    path:"/medicalCenter/machineBook",
    name:"hospitalMachineBook",
    meta: { title: '一体机预约' },
    component:()=>import(/* webpackChunkName: "hospitalMachineBook" */ '@/views/hospitalMachineBook')
  },
  {
    path:"/personalCenter/personalList",
    name:"hospitalPersonalList",
    meta: { title: '个人中心tab页' },
    component:()=>import(/* webpackChunkName: "hospitalPersonalList" */ '@/views/hospitalPersonalList')
  },
  {
    path:"/medicalCenter/phoneBook",
    name:"hospitalTelephoneBook",
    meta: { title: '电话预约' },
    component:()=>import(/* webpackChunkName: "hospitalTelephoneBook" */ '@/views/hospitalTelephoneBook')
  },
  {
    path:"/medicalCenter/wechatBook",
    name:"hospitalWechatBook",
    meta: { title: '微信预约' },
    component:()=>import(/* webpackChunkName: "hospitalWechatBook" */ '@/views/hospitalWechatBook')
  },
  {
    path:"/medicalCenter/websiteBook",
    name:"hospitalWebsiteBook",
    meta: { title: '网站预约' },
    component:()=>import(/* webpackChunkName: "hospitalWebsiteBook" */ '@/views/hospitalWebsiteBook')
  },
  {
    path:"/personalCenter/hospitalEnroll",
    name:"hospitalEnroll",
    meta: { title: '感谢报名' },
    component:()=>import(/* webpackChunkName: "hospitalEnroll" */ '@/views/hospitalEnroll')
  },
  {
    path:"/personalCenter/hospitalSignin",
    name:"hospitalSignin",
    meta: { title: '签到' },
    component:()=>import(/* webpackChunkName: "hospitalSignin" */ '@/views/hospitalSignin')
  },
  {
    path:"/personalCenter/hospitalPayQrCode",
    name:"hospitalPayQrCode",
    meta: { title: '支付二维码' },
    component:()=>import(/* webpackChunkName: "hospitalPayQrCode" */ '@/views/hospitalPayQrCode')
  },
  {
    path:"/medicalCenter/medicalPackageDetails",
    name:"physicalExaminationDetail",
    meta: { title: '体检套餐详情' },
    component:()=>import(/* webpackChunkName: "physicalExaminationDetail" */ '@/views/physicalExaminationDetail')
  },
  {
    path:"/medicalCenter/teamExam",
    name:"szTeamExam",
    meta: { title: '团检预约' },
    component:()=>import(/* webpackChunkName: "szTeamExam" */ '@/views/hospitalPhysicalTeamExam')
  },
  {
    path:"/medicalCenter/physicianVisitInformation",
    name:"physicianVisitInformation",
    meta: { title: '医师出诊信息' },
    component:()=>import(/* webpackChunkName: "physicianVisitInformation" */ '@/views/hospitalPhysicianVisitInfo')
  },
]